export default __webpack_public_path__ + "static/media/close.d52a7a37.svg";